import constants from "../../commonUtils/constants";
import * as actionTypes from "./actionTypes";
import { formatUploadLogData, getCamelCasedKeys } from "../../commonUtils/string.helper";

const initialState = {
  loading: false,
  loadingText: "",
  downloadFileLoading: false,
  listLoading: false,
  stepVal: 1,
  filters: constants.upload.filtersInitialState,
  uploadData: constants.upload.dataInitialState,
  viewLogData: constants.upload.dataInitialState,
  mappedColumns: [],
  additionalColumns: [],
  selectedColumns: [],
  uploadFile: null,
  activeTab: "mapped_fields",
  reviewData: constants.upload.dataInitialState,
  UploadLogData: {
    data: [],
    pagination: {
      currentPage: 1,
      perPage: constants.tableUI.defaultPerpage,
      total: 0,
    },
  },
  pageLoadData: {
    sourceType: [],
    masterProject: [],
    project: [],
    vendor: [],
    channelPartner: "",
    spoc: [],
    dataCategory: [],
    leadSource: [],
    uploadedBy: [],
  },
  errors: constants.upload.errorInitialState,
  errorMessage: "",
  fileColumns: {},
  destinationDataTypes: [],
  destinationColumns: {},
  fieldMappingTimeoutId: "",
};

const Uploads = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LOADING:
      return { ...state, loading: action.payload };

    case actionTypes.SET_LIST_LOADING:
      return { ...state, listLoading: action.payload };

    case actionTypes.SET_DOWNLOAD_LOADING:
      return { ...state, downloadFileLoading: action.payload };

    case actionTypes.SET_LOADING_TEXT:
      return { ...state, loadingText: action.payload };

    case actionTypes.SET_ERRORS:
      return { ...state, errors: action.payload };

    case actionTypes.SET_STEPVAL:
      return { ...state, stepVal: action.payload };

    case actionTypes.SET_UPLOAD_DATA:
      return { ...state, uploadData: action.payload };

    case actionTypes.SET_MAPPED_COLUMNS:
      return {
        ...state,
        mappedColumns: action.payload,
        errors:
          action.payload.length > 0
            ? action.payload.map(() => ({
                source: "",
                sourceType: "",
                destination: "",
                destType: "",
              }))
            : { ...state.errors, mappedColumns: [] },
      };

    case actionTypes.SET_ADDITIONAL_COLUMNS:
      return { ...state, additionalColumns: action.payload };

    case actionTypes.SET_FIELD_MAPPING_TIMEOUT_ID:
      return { ...state, fieldMappingTimeoutId: action.payload };

    case actionTypes.SET_SELECTED_COLUMNS: {
      const ersSelectedColums =
        action.payload.length > 0
          ? action.payload.map(() => ({
              source: "",
              sourceType: "",
              destination: "",
              destType: "",
            }))
          : [];

      return {
        ...state,
        selectedColumns: action.payload,
        errors: {
          ...constants.upload.errorInitialState,
          selectedColumns: ersSelectedColums,
        },
      };
    }

    case actionTypes.SET_ACTIVE_TAB:
      return { ...state, activeTab: action.payload };

    case actionTypes.SET_UPLOAD_FILE:
      return { ...state, uploadFile: action.payload };

    case actionTypes.SET_REVIEW_DATA:
      return { ...state, reviewData: action.payload };

    case actionTypes.SET_FILTERS:
      return { ...state, filters: action.payload };

    case actionTypes.RESET_UPLOAD_FORM:
      return {
        ...state,
        stepVal: 1,
        loading: false,
        uploadData: {
          ...constants.upload.dataInitialState,
          uploadedBy: action.user.id,
        },
        uploadFile: null,
        activeTab: "mapped_fields",
        errors: constants.upload.errorInitialState,
      };

    case actionTypes.GET_UPLOAD_LOGS_SUCCESS:
      return {
        ...state,
        listLoading: false,
        UploadLogData: action.payload,
        errors: constants.upload.errorInitialState,
        errorMessage: "",
      };

    case actionTypes.GET_UPLOAD_LOGS_FAILURE:
      return {
        ...state,
        listLoading: false,
        errors: action.payload.data,
        errorMessage: action.payload.message,
      };

    case actionTypes.GET_UPLOAD_LOG_DATA_SUCCESS: {
      const { uploadLog: rawUploadLog } = action.payload;
      const { file, ...uploadLog } = rawUploadLog;

      const data = formatUploadLogData(uploadLog);

      const mappedColumns = action.payload.mappedColumns || [];
      const additionalColumns = action.payload.additionalColumns || [];

      return {
        ...state,
        loading: false,
        stepVal: data.fieldMapping.status === "completed" ? 3 : 2,
        uploadData: {
          ...data,
          fileRowCount: file.row_count,
          fileColCount: file.col_count,
          fileSizeInMB: file.size_in_MB,
        },
        mappedColumns,
        additionalColumns,
        selectedColumns: additionalColumns,
        uploadFile: { ...file, name: file.unique_name },
        activeTab: data.pending ? "additional_fields" : "mapped_fields",
        destinationColumns: action.payload.destinationColumns,
        destinationDataTypes: action.payload.destinationDataTypes,
      };
    }

    case actionTypes.GET_UPLOAD_LOG_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.data,
        errorMessage: action.payload.message,
      };

    case actionTypes.VIEW_UPLOAD_LOG_SUCCESS: {
      const uploadLog = action.payload;
      const data = getCamelCasedKeys(uploadLog);

      data.file = {
        ...getCamelCasedKeys(data.file),
        name: uploadLog.file.unique_name,
      };

      return {
        ...state,
        loading: false,
        stepVal: 1,
        viewLogData: data,
        mappedColumns: uploadLog.mapped_columns,
        additionalColumns: uploadLog.additional_columns,
        selectedColumns: uploadLog.selected_columns,
        activeTab: "mapped_fields",
      };
    }

    case actionTypes.VIEW_UPLOAD_LOG_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.data,
        errorMessage: action.payload.message,
      };

    case actionTypes.CHANGE_FILE_SUCCESS:
      return {
        ...state,
        loading: false,
        uploadData: {
          ...state.uploadData,
          _id: action.payload._id,
          status: action.payload.status,
        },
        uploadFile: {
          ...state.uploadFile,
          ...action.payload.file,
        },
        mappedColumns: [],
        additionalColumns: [],
        selectedColumns: [],
        errors: constants.upload.errorInitialState,
      };

    case actionTypes.CHANGE_FILE_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.data,
      };

    case actionTypes.GET_MAPPED_FIELDS_SUCCESS: {
      const fields = formatUploadLogData(action.payload.uploadLog);
      const columnMapping = fields.fieldMapping.column_mapping;
      const formIsReset =
        state.uploadData.sourceType === "" && state.uploadFile === null;

      return {
        ...state,
        loading: false,
        stepVal: formIsReset
          ? 1
          : fields.fieldMapping.status === "completed" && columnMapping
          ? 3
          : 2,
        uploadData: formIsReset
          ? constants.upload.dataInitialState
          : {
              ...state.uploadData,
              status: "completed",
            },
        mappedColumns: columnMapping,
        additionalColumns: [],
        destinationColumns: action.payload.destinationColumns,
        destinationDataTypes: action.payload.destinationDataTypes,
      };
    }

    case actionTypes.GET_MAPPED_FIELDS_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.data,
        errorMessage: action.payload.message,
      };

    case actionTypes.UPDATE_METADATA_SUCCESS: {
      const formIsReset =
        state.uploadData.sourceType === "" && state.uploadFile === null;

      return {
        ...state,
        loading: false,
        stepVal: 2,
        uploadData: formIsReset
          ? constants.upload.dataInitialState
          : {
              ...state.uploadData,
              status: "metadata_updated",
            },
        errors: constants.upload.errorInitialState,
        errorMessage: "",
      };
    }

    case actionTypes.UPDATE_METADATA_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.data,
        errorMessage: action.payload.message,
      };

    case actionTypes.LOAD_PAGE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        pageLoadData: action.payload,
        errors: constants.upload.errorInitialState,
        errorMessage: "",
      };

    case actionTypes.LOAD_PAGE_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.data,
        errorMessage: action.payload.message,
      };

    case actionTypes.UPLOAD_FILES_SUCCESS:
      return {
        ...state,
        loading: false,
        uploadData: {
          ...state.uploadData,
          _id: action.payload._id,
          status: action.payload.status,
        },
        uploadFile: {
          ...state.uploadFile,
          ...action.payload.file,
        },
        errors: constants.upload.errorInitialState,
        errorMessage: "",
      };

    case actionTypes.UPLOAD_FILES_FAILURE: {
      const stateErrors = constants.upload.errorInitialState;

      if (action?.payload?.data?.["file.type"]) {
        stateErrors.file.type = action.payload.data["file.type"];
      }

      return {
        ...state,
        loading: false,
        errors: stateErrors,
        errorMessage: action.payload.message,
      };
    }

    case actionTypes.GET_PROJECTS_FOR_MASTER_SUCCESS:
      return {
        ...state,
        pageLoadData: {
          ...state.pageLoadData,
          projects: action.payload,
        },
      };

    case actionTypes.RUN_ETL_PROCESS_SUCCESS:
      return { ...state, loading: false };

    case actionTypes.RUN_ETL_PROCESS_FAILURE:
      return { ...state, loading: false };

    case actionTypes.REJECT_REVIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        uploadData: {
          ...state.uploadData,
          ...action.payload,
        },
        errors: constants.upload.errorInitialState,
      };

    case actionTypes.REJECT_REVIEW_FAILURE:
      return { ...state, loading: false };

    case actionTypes.DOWNLOAD_FILE_SUCCESS:
      return {
        ...state,
        loading: false,
        errors: constants.upload.errorInitialState,
        errorMessage: "",
      };

    case actionTypes.DOWNLOAD_FILE_FAILURE:
      return {
        ...state,
        loading: false,
        errors: constants.upload.errorInitialState,
        errorMessage: action.payload.message,
      };

    default:
      return state;
  }
};

export default Uploads;